"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyCard = CompanyCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const icons_1 = require("@ant-design/icons");
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const CompanyCard_style_1 = require("./CompanyCard.style");
function CompanyCard({ company, isSelected, onClick }) {
    const companyLogoSrc = (0, get_cdn_image_url_1.getCdnImageUrl)({
        file: `web/company/${company.image}`,
        transformation: 'w_140,h_140,c_limit',
    });
    return ((0, jsx_runtime_1.jsxs)(CompanyCard_style_1.CompanyCardWrapper, { isSelected: isSelected, onClick: onClick, children: [isSelected && ((0, jsx_runtime_1.jsx)(CompanyCard_style_1.CheckIconWrapper, { children: (0, jsx_runtime_1.jsx)(icons_1.CheckCircleFilled, {}) })), (0, jsx_runtime_1.jsxs)(CompanyCard_style_1.CompanyCardContent, { children: [(0, jsx_runtime_1.jsx)(CompanyCard_style_1.CompanyLogoWrapper, { children: (0, jsx_runtime_1.jsx)(CompanyCard_style_1.ImageBlock, { children: (0, jsx_runtime_1.jsx)("img", { src: companyLogoSrc, alt: "logo" }) }) }), (0, jsx_runtime_1.jsxs)(CompanyCard_style_1.CompanyNameAndAreaWrapper, { children: [(0, jsx_runtime_1.jsx)(CompanyCard_style_1.CompanyName, { children: company.name }), (0, jsx_runtime_1.jsx)(CompanyCard_style_1.CompanyArea, { children: company.area })] })] })] }));
}
